import React, {useState, useEffect} from "react";

import {Navigate, useNavigate} from "react-router-dom";
import {Formik, Field, Form, FieldArray} from 'formik';
import * as Yup from 'yup';
import { cpf } from "cpf-cnpj-validator";
import InputMask from 'react-input-mask';
import format from "date-fns/format";

import Map from 'components/Map'
import {FixedRating} from "components/Rating";
import Button from "components/Button";
import {ModalApp} from "components/Modal";
import {LoaderSmall} from "components/Loader";
import {ResumeHotel} from "components/Resume";

import {useApp} from "contexts/AppContext";
import {setTravellersHotelAction} from "contexts/reducers/hotels/actions";

import {
    Container,
    CheckIn,
    Line,
    Resume,
    Points,
    Title,
    ValuePoints,
    LocationMap,
} from "./styles";
import {CheckboxContainer} from "../CarConductor/styles";

export function HotelTravellers() {

    const [openReserveDetails, setOpenReserveDetails] = useState(false);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false)

    const { hotelState, hotelDispatch } = useApp()
    const { datesSearchHotel, room, hotel, travellers } = hotelState

    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 2000)
    },[])

    const coords = {
        lat: hotel?.address && JSON.parse(hotel?.address?.latitude),
        lng: hotel?.address && JSON.parse(hotel?.address?.longitude),
    }

    const selected = {
        name: hotel?.name,
        show: true
    }

    const externalProperties = room?.externalProperties && JSON.parse(room?.externalProperties)

    const handleModal = () => {
        setOpen(!open);
    };

    const initialValues = {
        travellers: travellers,
    };

    if (!hotel?.name) return <Navigate to="/loja/search-hotels-result" />

    if (loading) return <LoaderSmall />

    return (
        <Container>
            <p className="resume">Resumo da Reserva</p>

            <div className="row">
                <div className="col-8">
                    <span className="hotel-name">{hotel?.name}</span>
                </div>
                <div className="col-4 star">
                    <FixedRating value={hotel?.stars} size="small"/>
                </div>
            </div>

            <span className="map" onClick={handleModal}>
                <LocationMap/>
                {hotel?.address?.street + ', ' + hotel?.address?.number + ' - '}
                {hotel?.address?.city + ' ,'}
                {hotel?.address?.state}
            </span>

            <ModalApp show={open} handleModal={handleModal} isMap={true}>
                <Map params={coords} selected={selected} boxHotel="name" />
            </ModalApp>

            <CheckIn>
                <p className="top">Datas</p>
                <p>
                    Check-in
                    <span> {format(datesSearchHotel?.startDate, "dd/MM/yyyy")} </span>
                </p>
                <p>
                    Check-out
                    <span> {format(datesSearchHotel?.endDate, "dd/MM/yyyy")} </span>
                </p>
            </CheckIn>

            {openReserveDetails && (
                <div>
                    <Points>
                        <Title>Diárias</Title>
                        <div className="dots"/>
                        <ValuePoints>{datesSearchHotel?.days} diária(s)</ValuePoints>
                    </Points>
                    <Points>
                        <Title>Quarto</Title>
                        <div className="dots"/>
                        <ValuePoints>{ room?.name}</ValuePoints>
                    </Points>
                    <Points>
                        <Title>Alimentação</Title>
                        <div className="dots"/>
                        <ValuePoints>
                            { room?.board?.description === "Breakfast"
                                ? "Café da manhã incluso" : "Não incluso" }
                        </ValuePoints>
                    </Points>
                    <Points>
                        <Title>Cancelamento</Title>
                        <div className="dots"/>
                        <ValuePoints>
                            { externalProperties["Refundable"] === "False"
                                && "Sem Rebolso"}

                            { externalProperties["Refundable"] === "True"
                                && "Com Rebolso" }
                        </ValuePoints>
                    </Points>
                </div>
            )}

            <Button onClick={() => setOpenReserveDetails(!openReserveDetails)}>
                {openReserveDetails ? "Fechar" : "Ver Detalhes"}
            </Button>

            <Line />

            <Formik
                initialValues={initialValues}
                validationSchema={Yup.object({
                    travellers: Yup.array().of(
                        Yup.object().shape({
                            firstName: Yup.string().required(),
                            lastName: Yup.string().required(),
                            document: Yup.string().required().test(function (value) {
                                if (value) {
                                    return cpf.isValid(value);
                                } else {
                                    return false
                                }
                            }),
                            birthDate: Yup.string().required().min(10),
                            gender: Yup.string().required(),
                        })
                    )
                })}
                onSubmit={async (values) => {
                    await new Promise((r) => setTimeout(r, 500));
                    hotelDispatch(setTravellersHotelAction(values.travellers))
                    navigate("/loja/checkout-travel/hotel");
                }}
            >
                {({values,  setFieldValue, errors, touched, setFieldTouched}) => (
                    <Form>
                        <FieldArray name="travellers">
                            {() => (
                                <div>
                                    {values.travellers.length > 0 &&
                                        values.travellers.map((traveller, index) =>

                                            <div key={index} className="row gy-3 mb-3">

                                                <span className="label">Dados do Hóspede {index + 1}</span>

                                                <div className="col-12">
                                                    <Field
                                                        name={`travellers.${index}.firstName`}
                                                        placeholder="Primeiro nome"
                                                        className={`form-control form-control-custom border-custom shadow-none
                                                        ${ errors?.travellers !== undefined && errors?.travellers[index] !== undefined
                                                            ?
                                                            touched.travellers && touched.travellers[index] && touched.travellers[index].firstName &&
                                                            errors.travellers[index].firstName && 'is-invalid' : ''}`}
                                                    />
                                                </div>

                                                <div className="col-12">
                                                    <Field
                                                        name={`travellers.${index}.lastName`}
                                                        placeholder="Último sobrenome"
                                                        className={`form-control form-control-custom border-custom shadow-none
                                                        ${ errors?.travellers !== undefined && errors?.travellers[index] !== undefined
                                                            ? touched.travellers && touched.travellers[index] && touched.travellers[index].lastName &&
                                                            errors.travellers[index].lastName && 'is-invalid' : ''}`}
                                                    />
                                                </div>

                                                <div className="col-6">
                                                    <InputMask
                                                        name={`travellers.${index}.document`}
                                                        mask="999.999.999-99"
                                                        onClick={() => setFieldTouched(`travellers.${index}.document`, true)}
                                                        onChange={(e) => setFieldValue(`travellers.${index}.document`, e.target.value )}
                                                        className={`form-control form-control-custom border-custom shadow-none
                                                        ${ errors?.travellers !== undefined && errors?.travellers[index] !== undefined
                                                            ? touched.travellers && touched.travellers[index] && touched.travellers[index].document &&
                                                            errors.travellers[index].document && 'is-invalid' : ''}`}
                                                        maskChar={null}
                                                        placeholder="CPF"
                                                        inputMode="numeric"
                                                        defaultValue={values.travellers[index].document}
                                                    />
                                                </div>

                                                <div className="col-6">
                                                    <InputMask
                                                        name={`travellers.${index}.birthDate`}
                                                        mask="99/99/9999"
                                                        maxLength={10}
                                                        onClick={() => setFieldTouched(`travellers.${index}.birthDate`, true)}
                                                        onChange={(e) => setFieldValue(`travellers.${index}.birthDate`, e.target.value)}
                                                        className={`form-control form-control-custom border-custom shadow-none
                                                        ${ errors?.travellers !== undefined && errors?.travellers[index] !== undefined
                                                            ? touched.travellers && touched.travellers[index] && touched.travellers[index].birthDate &&
                                                            errors.travellers[index].birthDate  && 'is-invalid' : ''}`}
                                                        maskChar={null}
                                                        placeholder="Data de nascimento"
                                                        inputMode="numeric"
                                                        defaultValue={values.travellers[index].birthDate}
                                                    />
                                                </div>

                                                <div className="col-12">
                                                    <div className="d-grid gap-3 mt-3">
                                                        <div className="d-flex align-items-center gap-2">
                                                            <Field
                                                                type="radio"
                                                                name={`travellers.${index}.gender`}
                                                                value="male"
                                                                className={`custom-radio ${ errors?.travellers !== undefined && errors?.travellers[index] !== undefined
                                                                    ? touched.travellers && touched.travellers[index] && touched.travellers[index].gender &&
                                                                    errors.travellers[index].gender && 'border-danger' : ''}`}
                                                            />
                                                            <label htmlFor="male">Masculino</label>
                                                        </div>

                                                        <div className="d-flex align-items-center gap-2">
                                                            <Field
                                                                type="radio"
                                                                name={`travellers.${index}.gender`}
                                                                value="female"
                                                                className={`custom-radio ${ errors?.travellers !== undefined && errors?.travellers[index] !== undefined
                                                                    ? touched.travellers && touched.travellers[index] && touched.travellers[index].gender &&
                                                                    errors.travellers[index].gender && 'border-danger' : ''}`}
                                                            />
                                                            <label htmlFor="female">Feminino</label>
                                                        </div>

                                                        <div className="d-flex align-items-center gap-2">
                                                            <Field
                                                                type="radio"
                                                                name={`travellers.${index}.gender`}
                                                                value="not"
                                                                className={`custom-radio ${ errors?.travellers !== undefined && errors?.travellers[index] !== undefined
                                                                    ? touched.travellers && touched.travellers[index] && touched.travellers[index].gender &&
                                                                    errors.travellers[index].gender && 'border-danger' : ''}`}
                                                            />
                                                            <label>Não informar</label>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                </div>
                            )}
                        </FieldArray>

                        <div className="my-5">
                            <Resume className="border-bottom w-100 pb-4">
                                Resumo da Reserva
                            </Resume>
                            <ResumeHotel />
                        </div>

                        <div className="mt-4 mb-5">
                            <Button type="submit">CONTINUAR</Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </Container>
    );
}
